import getLocalString from "constants/Localization";
import { useArchiveEmployeeMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useArchiveEmployee() {
  const [mutation, { loading, data, error }] = useArchiveEmployeeMutation({
    refetchQueries: ["getEmployees", "customGetEmployees"],
  });

  const [archiveEmployee, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "archiveEmployee",
    },
    {
      successMessage: getLocalString("organization.archive-employee-success"),
      failureMessage: getLocalString("organization.archive-employee-failure"),
    }
  );

  return [archiveEmployee, context] as const;
}
